import { styled } from 'styled-components';
import { colors } from '@styles';
import { textMixin } from '@styles/mixins';

export const StyledTable = styled.div`
    .ant-table-thead > tr > th {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16px;
        text-align: left;
        height: 45px;
        padding-right: 1.1em !important;
    }

    .ant-table-footer {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16px;
        text-align: left;
    }

    table > tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16px;
        text-align: left;
        height: 30px;
    }

    .ant-table-summary {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16px;
        height: 45px;
        tr > td:first-child {
            border-bottom-left-radius: 8px;
        }

        tr > td:last-child {
            border-bottom-right-radius: 8px;
        }
    }
    .ant-table-summary .ant-table-cell {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
    }
`;

export const StyledSum = styled.div`
    text-align: right;
    padding-right: 0.5em;
`;
